"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NativeMenuContext", {
    enumerable: true,
    get: function() {
        return NativeMenuContext;
    }
});
function _react() {
    const data = require("react");
    _react = function() {
        return data;
    };
    return data;
}
const NativeMenuContext = /*#__PURE__*/ (0, _react().createContext)(false);

//# sourceMappingURL=NativeMenuContext.js.map
